module.exports = __webpack_public_path__ + "5ac3cbf3a360180f5814b9ccbb647b86.png";